const events = {};

const pigeon = {
  subscribe(eventName, callback) {
    if (!Object.prototype.hasOwnProperty.call(events, eventName)) {
      events[eventName] = [];
    }

    events[eventName].push(callback);
  },
  publish(eventName, data) {
    if (!events[eventName]) {
      return;
    }

    for (let listener of events[eventName]) {
      listener(data);
    }
  }
};

export default pigeon;
